<div class="sidebar-container">
  <!-- Header/Logo -->
  <div class="sidebar-header">
    <img src="/vessel-icon.png" alt="CuanOne" class="logo-icon" />
    <div class="logo-text">CuanOne</div>
  </div>

  <!-- Navigation Items -->
  <nav class="navigation-section">
    <!-- Home/Dashboard -->
    <a *ngIf="canAccessRoute('/dashboard')" class="nav-item" [class.active]="isRouteActive('/dashboard')"
      routerLink="/dashboard" routerLinkActive="active">
      <i-lucide [name]="Activity" [size]="20"></i-lucide>
      <span>Dashboard</span>
    </a>

    <!-- Launch Board -->
    <a *ngIf="canAccessRoute('/launch-board')" class="nav-item" [class.active]="isRouteActive('/launch-board')"
      routerLink="/launch-board" routerLinkActive="active">
      <i-lucide [name]="Anchor" [size]="20"></i-lucide>
      <span>Launch Board</span>
      <b class="clients-badge" *ngIf="requestedLaunchCount > 0">{{ requestedLaunchCount }}</b>
    </a>

    <!-- POS -->
    <a *ngIf="canAccessRoute('/pos')" class="nav-item" [class.active]="isRouteActive('/pos')" routerLink="/pos"
      routerLinkActive="active">
      <i-lucide [name]="ShoppingCart" [size]="20"></i-lucide>
      <span>POS & Shop</span>
    </a>

    <!-- FLEET & STORAGE Section -->
    <div
      *ngIf="canAccessRoute('/vessels') || canAccessRoute('/clients') || canAccessRoute('/lease-management') || canAccessRoute('/dry-storage')"
      class="section-label">FLEET & STORAGE</div>

    <!-- Clients -->
    <a *ngIf="canAccessRoute('/clients')" class="nav-item clients-nav" [class.active]="isRouteActive('/clients')"
      routerLink="/clients" routerLinkActive="active">
      <i-lucide [name]="Users" [size]="20"></i-lucide>
      <span>Clients</span>
      <b class="clients-badge" *ngIf="prospectiveCount > 0">{{ prospectiveCount }}</b>
    </a>

    <!-- Vessels -->
    <a *ngIf="canAccessRoute('/vessels')" class="nav-item clients-nav" [class.active]="isRouteActive('/vessels')"
      routerLink="/vessels" routerLinkActive="active">
      <i-lucide [name]="Ship" [size]="20"></i-lucide>
      <span>Vessels</span>
      <b class="clients-badge" *ngIf="vesselAttentionCount > 0">{{ vesselAttentionCount }}</b>
    </a>



    <!-- Storage Contracts -->
    <a *ngIf="canAccessRoute('/lease-management')" class="nav-item" [class.active]="isRouteActive('/lease-management')"
      routerLink="/lease-management" routerLinkActive="active">
      <i-lucide [name]="FileSignature" [size]="20"></i-lucide>
      <span>Storage Contracts</span>
      <b class="clients-badge" *ngIf="storageContractsCount > 0">{{ storageContractsCount }}</b>
    </a>

    <!-- Dry Storage Racks -->
    <a *ngIf="canAccessRoute('/dry-storage')" class="nav-item" [class.active]="isRouteActive('/dry-storage')"
      routerLink="/dry-storage" routerLinkActive="active">
      <i-lucide [name]="Box" [size]="20"></i-lucide>
      <span>Dry Storage Racks</span>
    </a>

    <!-- BACK OFFICE Section (Launch Board lives above; not repeated here) -->
    <div
      *ngIf="canAccessRoute('/billing') || canAccessRoute('/reports') || canAccessRoute('/fuel-management') || canAccessRoute('/inventory')"
      class="section-label">BACK OFFICE</div>

    <!-- Billing & Invoices -->
    <a *ngIf="canAccessRoute('/billing')" class="nav-item nav-item-billing-badges"
      [class.active]="isRouteActive('/billing')" routerLink="/billing" routerLinkActive="active">
      <i-lucide [name]="CreditCard" [size]="20"></i-lucide>
      <span>Billing & Invoices</span>
      <b class="clients-badge billing-badge-overdue" *ngIf="billingAttentionCount > 0"
        title="Draft + Issued + Overdue">{{ billingAttentionCount }}</b>
    </a>

    <!-- Reports -->
    <a *ngIf="canAccessRoute('/reports')" class="nav-item" [class.active]="isRouteActive('/reports')"
      routerLink="/reports" routerLinkActive="active">
      <i-lucide [name]="BarChart3" [size]="20"></i-lucide>
      <span>Reports</span>
    </a>

    <!-- Fuel Management -->
    <a *ngIf="canAccessRoute('/fuel-management')" class="nav-item" [class.active]="isRouteActive('/fuel-management')"
      routerLink="/fuel-management" routerLinkActive="active">
      <i-lucide [name]="Fuel" [size]="20"></i-lucide>
      <span>Fuel Management</span>
    </a>

    <!-- Retail Inventory -->
    <a *ngIf="canAccessRoute('/inventory')" class="nav-item" [class.active]="isRouteActive('/inventory')"
      routerLink="/inventory" routerLinkActive="active">
      <i-lucide [name]="Package" [size]="20"></i-lucide>
      <span>Retail Stock</span>
    </a>

    <!-- SYSTEM Section -->
    <div
      *ngIf="canAccessRoute('/audit-logs') || canAccessRoute('/marina-settings') || canAccessRoute('/system-settings')"
      class="section-label">SYSTEM</div>

    <!-- System Logs -->
    <a *ngIf="canAccessRoute('/audit-logs')" class="nav-item" [class.active]="isRouteActive('/audit-logs')"
      routerLink="/audit-logs" routerLinkActive="active">
      <i-lucide [name]="FileText" [size]="20"></i-lucide>
      <span>System Logs</span>
    </a>

    <!-- Marina Settings (for Marina users and System admins with marina selected) -->
    <a *ngIf="canAccessRoute('/marina-settings')" class="nav-item" [class.active]="isRouteActive('/marina-settings')"
      routerLink="/marina-settings" routerLinkActive="active">
      <i-lucide [name]="Settings" [size]="20"></i-lucide>
      <span>Marina Settings</span>
    </a>

    <!-- System Settings (for System admin only) -->
    <a *ngIf="canAccessRoute('/system-settings')" class="nav-item" [class.active]="isRouteActive('/system-settings')"
      routerLink="/system-settings" routerLinkActive="active">
      <i-lucide [name]="Settings" [size]="20"></i-lucide>
      <span>System Settings</span>
    </a>
  </nav>

  <!-- Footer -->
  <div class="sidebar-footer">
    <div class="version">{{ version }}</div>
  </div>
</div>